// Fjalëkryqi design tokens — extracted from /new-design/*.html mockups.
// Single source of truth for Vuetify themes; do not duplicate hex values elsewhere.

const sharedColors = {
  primary: '#195de6',
  secondary: '#9da6b8',
  error: '#dc2626',
  success: '#16a34a',
  warning: '#f59e0b',
  info: '#0ea5e9',
}

export const fjalekryqiLight = {
  dark: false,
  colors: {
    ...sharedColors,
    background: '#f6f6f8',
    surface: '#ffffff',
    'surface-variant': '#e5e7eb',
    'surface-bright': '#ffffff',
    'on-background': '#0f172a',
    'on-surface': '#0f172a',
    'grid-cell': '#e5e7eb',
    'grid-cell-active': '#a3b8e8',
    'grid-cell-correct': '#86c39e',
    'grid-block': '#475569',
    'grid-gutter': '#cbd5e1',
  },
  variables: {
    'border-color': '#cbd5e1',
    'border-opacity': 1,
  },
}

export const fjalekryqiDark = {
  dark: true,
  colors: {
    ...sharedColors,
    background: '#111621',
    surface: '#1c212b',
    'surface-variant': '#292e38',
    'surface-bright': '#1e2330',
    'on-background': '#ffffff',
    'on-surface': '#ffffff',
    'grid-cell': '#292e38',
    'grid-cell-active': '#2d4079',
    'grid-cell-correct': '#1f5d3c',
    'grid-block': '#000000',
    'grid-gutter': '#000000',
  },
  variables: {
    'border-color': '#1e2330',
    'border-opacity': 1,
  },
}

export const STORAGE_KEYS = {
  themePreference: 'fjalekryqi:theme',
}

export function resolveInitialThemeName() {
  if (typeof window === 'undefined') return 'fjalekryqiDark'
  const stored = window.localStorage.getItem(STORAGE_KEYS.themePreference)
  if (stored === 'light') return 'fjalekryqiLight'
  if (stored === 'dark') return 'fjalekryqiDark'
  return window.matchMedia?.('(prefers-color-scheme: light)').matches
    ? 'fjalekryqiLight'
    : 'fjalekryqiDark'
}
